<template>
	<div>
		<el-form :inline="true" :model="formInline" class="user-search">
			<el-form-item label="年份：">
				<el-date-picker
					v-model="inputYear"
					type="year"
					:clearable="false"
					value-format="yyyy"
					placeholder="选择年"
					:editable="false"
					format="yyyy年"
					size="small"
					@change="changeYear"
				></el-date-picker>
			</el-form-item>
			<el-form-item>
				<span class="tip">按上线商品类型(镜片类型)统计 1~12 月实际出入库数量（入库时间 / 出库时间）</span>
			</el-form-item>
		</el-form>
		<el-table
			v-loading="loading"
			:data="tableData"
			border
			size="small"
			height="630"
			:header-cell-style="{ background: '#f5f7fa', color: '#333' }"
			show-summary
			:summary-method="getSummaries"
		>
			<el-table-column type="index" label="序号" width="60" align="center" fixed="left"></el-table-column>
			<el-table-column prop="goodsTypeName" label="镜片类型（上线商品类型）" min-width="240" align="center" fixed="left"></el-table-column>
			<el-table-column v-for="m in 12" :key="'m' + m" :label="m + '月'" align="center">
				<el-table-column :key="'i' + m" label="入库" width="100" align="center">
					<template slot-scope="scope">{{ fmtCount(scope.row.inputCounts[m - 1]) }}</template>
				</el-table-column>
				<el-table-column :key="'o' + m" label="出库" width="100" align="center">
					<template slot-scope="scope">{{ fmtCount(scope.row.outputCounts[m - 1]) }}</template>
				</el-table-column>
			</el-table-column>
			<el-table-column label="全年合计" align="center">
				<el-table-column label="入库" width="100" align="center">
					<template slot-scope="scope">{{ fmtCount(scope.row.totalInputCount) }}</template>
				</el-table-column>
				<el-table-column label="出库" width="100" align="center">
					<template slot-scope="scope">{{ fmtCount(scope.row.totalOutputCount) }}</template>
				</el-table-column>
			</el-table-column>
		</el-table>
	</div>
</template>

<script>
import { GetInOutStatistics } from "@/api/receiptApi.js";
export default {
	data() {
		return {
			loading: false,
			inputYear: new Date().getFullYear().toString(),
			formInline: {
				year: new Date().getFullYear()
			},
			tableData: []
		};
	},
	created() {
		this.loadData();
	},
	methods: {
		// 数量为 0 显示 --
		fmtCount(val) {
			return Number(val) || 0 ? val : "--";
		},
		loadData() {
			this.loading = true;
			GetInOutStatistics(this.formInline)
				.then((res) => {
					if (res.code == 1) {
						this.tableData = res.data && res.data.dtls ? res.data.dtls : [];
					} else {
						this.$message({ type: "info", message: res.msg });
						this.tableData = [];
					}
				})
				.catch(() => {
					this.$message.error("数据加载失败，请稍后再试！");
				})
				.finally(() => {
					this.loading = false;
				});
		},
		changeYear(val) {
			if (val) {
				this.formInline.year = parseInt(val);
			}
			this.loadData();
		},
		// 合计行：列结构 = [类型列, 1月入, 1月出, ..., 12月入, 12月出, 全年入, 全年出]
		getSummaries(param) {
			const { columns, data } = param;
			const sums = [];
			columns.forEach((column, index) => {
				if (index === 0) {
					sums[index] = "合计";
					return;
				}
				if (index === 1) {
					sums[index] = "";
					return;
				}
				const pairIndex = index - 2;
				let sum = 0;
				data.forEach((row) => {
					if (pairIndex >= 24) {
						sum += Number(pairIndex === 24 ? row.totalInputCount : row.totalOutputCount) || 0;
					} else {
						const arr = pairIndex % 2 === 0 ? row.inputCounts : row.outputCounts;
						sum += Number((arr && arr[Math.floor(pairIndex / 2)]) || 0);
					}
				});
				sums[index] = sum || "--";
			});
			return sums;
		}
	}
};
</script>

<style scoped lang="scss">
.user-search {
	margin-bottom: 10px;
	.tip {
		color: #909399;
		font-size: 12px;
	}
}
</style>
